import React from 'react'
import { graphql, PageProps } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import Masonry from 'react-masonry-css'

const breakpointColumns = {
  default: 3,
  1100: 3,
  700: 2,
  500: 1,
}

export const TopPage: React.VFC<PageProps> = ({ location, data }) => {
  const { allContentfulPhoto } = data

  return (
    <div className="flex flex-col min-h-screen">
      <header className="text-center text-3xl py-5">Photo portrait</header>
      <main className="flex-1 p-10 max-w-7xl mx-auto w-full">
        <Masonry
          breakpointCols={breakpointColumns}
          columnClassName="mr-5"
          className="flex mr-[-20px]"
        >
          {allContentfulPhoto.edges.map((photo) => (
            <GatsbyImage
              className="drop-shadow-lg mb-5"
              alt={photo.node.image.title}
              image={photo.node.image.gatsbyImageData}
            />
          ))}
        </Masonry>
      </main>
    </div>
  )
}

export default TopPage

export const pageQuery = graphql`
  query {
    allContentfulPhoto {
      edges {
        node {
          image {
            gatsbyImageData
            title
          }
        }
      }
    }
  }
`
